import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import _ from 'underscore';
import classnames from 'classnames';
import D13nStore from 'stores/plugins/d13n';
import GuestsDropdown from 'views/ui/form_elements/dropdown/guests';
import { numberOrString } from 'lib/prop_types';
import { roundPrice } from 'lib/pricing_utils';
import StoreInterestMixin from 'lib/flux/store/interest_mixin';
import IntegrationActionCreator from 'action_creators/integration';
import Slideshow from 'views/shared/tours/page/gallery/slideshow';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import Truncate from 'react-truncate';
import { MoreLink } from 'views/anyguide/messages/styles';
import { translateUnitNoun } from 'services/translation/unitNounMessages';

const productMessages = defineMessages({
  experience: { defaultMessage: 'experience' },
  tour: { defaultMessage: 'tour' },
  event: { defaultMessage: 'event' },
  activity: { defaultMessage: 'activity' },
});

const Addon = createReactClass({
  displayName: 'BookingRequest-Addon',

  mixins: [StoreInterestMixin],

  propTypes: {
    addon: PropTypes.object.isRequired,
    defaultGuests: numberOrString.isRequired,
    selectedGuests: numberOrString,
    isSelected: PropTypes.bool.isRequired,
    update: PropTypes.func.isRequired,
    addonAvailability: PropTypes.object.isRequired,
    date: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
  },

  toggle() {
    if (this._calculateAddonCapacity() > 0) {
      this.props.update(this.props.addon.id, {
        selected: !this.props.isSelected,
        count: this._currentValue(),
      });
    }
  },

  getStoreInterests() {
    return {
      parentViewport: 'integration.parentViewport',
    };
  },

  getInitialState() {
    return {
      slideshowVisible: false,
      parentViewport: null,
      truncated: false,
      maxLines: 3,
    };
  },

  componentDidMount() {
    if (this._calculateAddonCapacity() <= 0) {
      this.props.update(this.props.addon.id, {
        selected: false,
        count: 0,
      });
    }
  },

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.time !== this.props.time ||
      prevProps.date !== this.props.date
    ) {
      if (this._calculateAddonCapacity() <= 0) {
        this.props.update(this.props.addon.id, {
          selected: false,
          count: 0,
        });
      }
    }

    if (
      this.props.isSelected &&
      prevProps.totalGuests !== this.props.totalGuests
    ) {
      this.props.update(this.props.addon.id, {
        selected: this.props.isSelected,
        count: this._currentValue(),
      });
    }
  },

  countChanged(name, value) {
    this.props.update(this.props.addon.id, {
      selected: this.props.isSelected,
      count: value,
    });
  },

  _translateProduct(product) {
    const { intl } = this.props;
    const key = product?.toLowerCase();
    if (key && productMessages[key]) {
      return intl.formatMessage(productMessages[key]);
    }
    return product;
  },

  _price() {
    return this.props.addon.unit_price_formatted
      ? roundPrice(this.props.addon.unit_price_formatted)
      : '';
  },

  _getProductUnitName() {
    const { intl } = this.props;
    let product = D13nStore.d('product');
    if (product === 'tour') product = 'experience'; // WEB-1033
    return (
      this._translateProduct(product) ||
      intl.formatMessage({ id: 'EXPERIENCE', defaultMessage: 'experience' })
    );
  },

  _getAddonUnitName() {
    const { intl } = this.props;
    return (
      translateUnitNoun(intl, D13nStore.d('priceable_addon'), {
        lowercase: true,
      }) || translateUnitNoun(intl, 'guest', { lowercase: true })
    );
  },

  _synchro() {
    return this.props.addon.per_person && !this.props.addon.independent_qty;
  },

  _currentValue() {
    const { selectedGuests, totalGuests, defaultGuests, addon } = this.props;
    const guests =
      addon.unit_type == 'person'
        ? Math.min(selectedGuests, totalGuests)
        : selectedGuests;
    let retVal = selectedGuests || defaultGuests;
    if (this._synchro()) {
      retVal = totalGuests;
    }
    return retVal;
  },

  _guestsDropdownProps() {
    const { intl, addon } = this.props;
    let labels = {};
    let singular = '';
    let plural = '';
    if (addon.unit_type !== 'item') {
      singular = D13nStore.d('guest_addon');
      plural = D13nStore.d('guests_addon');
    }
    labels = {
      optionsLabel: translateUnitNoun(intl, singular, { lowercase: true }),
      optionsLabelPlural: translateUnitNoun(intl, plural, { lowercase: true }),
    };

    return {
      name: `addon-${addon.id}-guests`,
      min: 1,
      max: this._maxDropdownValue(),
      value: this._currentValue(),
      onChange: this.countChanged,
      disabled: this._synchro(),
      theme: `addon-${addon.unit_type}`,
      icon: <i className="icon af-triangle-down-2" />,
      ...labels,
    };
  },

  _calculateAddonCapacity(dropdownWithGuests = false) {
    const addonAvailability = this.props.addonAvailability;
    const addon = this.props.addon;
    const date = this.props.date;
    const time = this.props.time ? this.props.time.replace(' ', '0') : '';

    if (
      addon.max_capacity &&
      addon.id in addonAvailability &&
      date in addonAvailability[addon.id] &&
      time in addonAvailability[addon.id][date]
    ) {
      return addon.max_capacity - addonAvailability[addon.id][date][time];
    } else if (addon.max_capacity) {
      return addon.max_capacity;
    }

    return dropdownWithGuests ? this.props.totalGuests : 500;
  },

  _maxDropdownValue() {
    if (this.props.addon.unit_type === 'item') {
      return this._calculateAddonCapacity();
    }

    return Math.min(this._calculateAddonCapacity(true), this.props.totalGuests);
  },

  _renderPriceText() {
    const { addon } = this.props;
    const price = this._price();

    if (addon.unit_price === '0.00') {
      return <FormattedMessage id="FREE" defaultMessage="Free" />;
    }

    if (!addon.unit_price) {
      return '...';
    }

    if (addon.unit_type === 'item' && addon.per_person) {
      return (
        <FormattedMessage
          id="PRICE_AT_RATE_EACH"
          defaultMessage="@ {price} each"
          values={{ price }}
        />
      );
    }

    if (addon.unit_type === 'person' && addon.per_person) {
      return (
        <FormattedMessage
          id="PRICE_AT_RATE_PER_UNIT"
          defaultMessage="@ {price} per {unit}"
          values={{ price, unit: this._getAddonUnitName() }}
        />
      );
    }

    if (addon.per_tour) {
      return (
        <FormattedMessage
          id="PRICE_AT_RATE_PER_UNIT"
          defaultMessage="@ {price} per {unit}"
          values={{ price, unit: this._getProductUnitName() }}
        />
      );
    }

    return (
      <FormattedMessage
        id="PRICE_AT_RATE_SIMPLE"
        defaultMessage="@ {price}"
        values={{ price }}
      />
    );
  },

  _renderPrice() {
    const text = this._renderPriceText();

    return this._calculateAddonCapacity() <= 0 ? (
      <div className="price" data-testid="addon-price">
        <strike>{text}</strike>
        <div className="sold-out-add-on">
          <FormattedMessage id="SOLD_OUT" defaultMessage="Sold out" />
        </div>
      </div>
    ) : (
      <div className="price" data-testid="addon-price">
        {text}
      </div>
    );
  },

  showFullPicture() {
    IntegrationActionCreator.queryParentViewport();
    this.setState({ slideshowVisible: true });
  },

  closeGallery() {
    this.setState({ slideshowVisible: false });
  },

  _renderPicture() {
    const slideshowProps = {
      parentViewport:
        this.state.parentViewport && this.state.parentViewport.toJS(),
      isVisible: this.state.slideshowVisible,
      photos: [this.props.addon.picture.full],
      onClose: this.closeGallery,
    };

    return (
      <div className="picture">
        <a className="picture-preview" onClick={this.showFullPicture}>
          <img alt="addon" src={this.props.addon.picture.thumb} />
        </a>
        <Slideshow {...slideshowProps} />
      </div>
    );
  },

  _renderQuantitySelector() {
    return (
      <div className="row addon-options">
        <div
          className="twelve wide column"
          role="group"
          aria-labelledby="additional-options"
        >
          <GuestsDropdown {...this._guestsDropdownProps()} />
        </div>
      </div>
    );
  },

  _handleToggleTruncate() {
    this.setState({
      truncated: false,
      maxLines: 1000,
    });
  },

  _handleTruncate(truncated) {
    if (truncated !== this.state.truncated) {
      this.setState({
        truncated,
      });
    }
  },

  // Returns description props with html removed
  _pureTextDescription() {
    const html = this.props.addon.description;
    const div = document.createElement('div');
    div.innerHTML = html;
    let text = div.textContent || div.innerText || '';
    return text.replace(/[\n\r]/g, '');
  },

  render() {
    const checkboxClassName = classnames(
      'ui',
      'toggle',
      'checkbox',
      'mirrored',
      {
        checked: this.props.isSelected,
      }
    );

    return (
      <div
        className="BookingRequest-Addons-addon ui grid"
        data-testid="addon-list"
      >
        <div className="row">
          <div className="eight wide column">
            <div className="name" data-testid="addon-name">
              {this.props.addon.name}
            </div>
            {this.props.addon.description != null ? (
              <div className={'description'} data-testid="addon-description">
                <Truncate
                  lines={this.state.maxLines}
                  onTruncate={(e) => this._handleTruncate(e)}
                  ellipsis={
                    <MoreLink
                      className="brand-color"
                      onClick={() => this._handleToggleTruncate()}
                    >
                      <FormattedMessage
                        id="MORE_ELLIPSIS"
                        defaultMessage="More..."
                      />
                    </MoreLink>
                  }
                >
                  {this._pureTextDescription()}
                </Truncate>
              </div>
            ) : null}
            {this._renderPrice()}

            {this.props.addon.picture != null ? this._renderPicture() : null}
          </div>
          <div
            className="four wide column"
            role="group"
            aria-labelledby="additional-options"
          >
            <div
              data-testid="addon-toggle"
              className={checkboxClassName}
              onClick={this.toggle}
              disabled={this._calculateAddonCapacity() <= 0}
            >
              <input type="checkbox" checked={this.props.isSelected} readOnly />
              <label>
                {this.props.isSelected ? (
                  <FormattedMessage id="YES" defaultMessage="Yes" />
                ) : (
                  <FormattedMessage id="NO" defaultMessage="No" />
                )}
              </label>
            </div>
          </div>
        </div>

        {this.props.isSelected ? this._renderQuantitySelector() : null}
      </div>
    );
  },
});

export default injectIntl(Addon);
